<script setup lang="ts">
import { cx } from '../ui'

const props = defineProps<{
  class?: string
  clickable?: boolean
}>()

const emit = defineEmits<{ click: [] }>()

function onKeyDown(e: KeyboardEvent) {
  if (!props.clickable) return
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault()
    emit('click')
  }
}
</script>

<template>
  <tr
    :class="cx('row-hover', clickable && 'cursor-pointer', props.class)"
    :tabindex="clickable ? 0 : undefined"
    :role="clickable ? 'link' : undefined"
    @click="clickable && emit('click')"
    @keydown="onKeyDown"
  >
    <slot />
  </tr>
</template>
